import React from 'react';
import {SvgIcon} from '../../icons/svgIcon';
import {IconType} from '../../icons/icons';
import classNames from 'clsx';
import './hibuButton.scss';
import {HibuTooltip} from '../hibuTooltip/hibuTooltip';

type LinkProps = {
    visible: boolean;
    className?: string;
    href: string | undefined;
    icon: IconType;
    tooltipKey?: string;
    size?: 'sm' | 'md';
    disabled?: boolean;
    placement?: any;
};

export const HibuLink = React.memo(({
                                        visible,
                                        className,
                                        href,
                                        icon,
                                        tooltipKey,
                                        size,
                                        disabled,
                                        placement
                                    }: LinkProps) => {
    if (!visible) {
        return null;
    }

    const cName = classNames('hibu-button', className, size || 'md', disabled && 'disabled');

    const hibuLink = disabled ? (
        <span className={cName}>
            <SvgIcon icon={icon}/>
        </span>
    ) : (
        <a className={cName} href={href} target={'_blank'} rel={'noopener noreferrer'}>
            <SvgIcon icon={icon} />
        </a>
    );

    if (tooltipKey) {
        return <HibuTooltip tooltipKey={tooltipKey} placement={placement}>{hibuLink}</HibuTooltip>;
    }

    return hibuLink;
});
